import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import Select, { components } from "react-select";
import classes from "../ServicesTable.module.scss"
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { E2Data } from "../../../lib/ddd/ddd";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import Workflow from "./Workflow";
import Button from "../../UI/Button";
import GenericModal from "../../UI/GenericModal";
import { GenericTooltip } from "../../integrationWizard/form/GenericTooltip";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const WorkflowTextInput = forwardRef(({orgData, deviceData, stepData, fieldName, instructions, formData, reloadDataForce}, ref) => {
    const [value, setValue] = useState(null);
    const [activeWf, setActiveWf] = useState();
    const [autorunWf, setAutorunWf] = useState();
    const [secondary, setSecondaryWf] = useState();
    const [windowWf, setWindowWf] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);
    const {t} = useTranslation();
    const wfref = useRef(null);
    

    const onInputChange = (value) => {
        setValue(value)
    };

    useEffect(() => {
        setValue(deviceData?.[fieldName]||stepData?.[fieldName]||null);
    },[deviceData,stepData]);

    useEffect(() => {
    }, [orgData]);

    useEffect(() => {
    }, [stepData]);

    useEffect(() => {
        if(Array.isArray(instructions?.workflows)){
            setActiveWf({ wf: instructions?.workflows});
        }
            
    }, [instructions]);

    const onBeforeSave = async (newData) => {
        if(!instructions?.workflows?.beforeSave) return true;
        let wf = null;
        if(isCreating()){
            wf = instructions?.workflows?.beforeSave?.create;
        }else if(isModifying()){
            wf = instructions?.workflows?.beforeSave?.modify;
        }else if(isDeleting()){
            wf = instructions?.workflows?.beforeSave?.delete;
        }

        if(!wf) return true;

        return new Promise((resolve) => {
            const handleComplete = (result) => {
                setActiveWf(null);
                resolve(result);
            };
            setActiveWf({ wf : JSON.parse(JSON.stringify(wf)), onComplete: handleComplete, autoExecute: true, formData : newData });
        });
    }
    const onAfterSave = async (newData) => {
        if(instructions?.saveWorkflow){
            return new Promise((resolve) => {
                const handleComplete = (result) => {
                    setSecondaryWf(null);
                    resolve(result);
                };
                setSecondaryWf({ wf : JSON.parse(JSON.stringify(instructions?.saveWorkflow)), onComplete: handleComplete, autoExecute: true, formData : newData });
            });
        }
        if(Array.isArray(instructions?.workflows)) return await onAfterSaveManual(newData);

        if(!instructions?.workflows?.afterSave && !Array.isArray(instructions?.workflows)) return true;
        let wf = null;
        if(isCreating()){
            wf = instructions?.workflows?.beforeSave?.create;
        }else if(isModifying()){
            wf = instructions?.workflows?.beforeSave?.modify;
        }else if(isDeleting()){
            wf = instructions?.workflows?.beforeSave?.delete;
        }
        if(!wf) wf = instructions?.workflows;

        if(!wf) return true;

        return new Promise((resolve) => {
            const handleComplete = (result) => {
                setActiveWf(null);
                resolve(result);
            };
            setActiveWf({ wf : JSON.parse(JSON.stringify(wf)), onComplete: handleComplete, autoExecute: true, formData : newData });
        });
    }

    const onAfterSaveManual = async (newData) => {
        return wfref?.current?.executeWorkflows(newData);
    }

    const isCreating = () => {
        if(!isEmpty(value) && isEmpty(deviceData?.[fieldName])) return true;
        return false;
    }
    const isModifying = () => {
        if(isEmpty(value) && isEmpty(deviceData?.[fieldName])) return false;
        return isDifferent();
    }
    const isDeleting = () => {
        if(isEmpty(value) && !isEmpty(deviceData?.[fieldName])) return true;
        return false;
    }

    const isEmpty = (str) => {
        return (!str || str?.trim().length === 0);
    }

    const isDifferent = () => {
        return value !== deviceData?.[fieldName];
    }

    const isButtonWf = (wf) => {
        if(!wf || !Array.isArray(wf)) return false;
        return wf.find(wf => wf?.execute?.button);
    }

    const workflowHasFields = (wf) => {
        if(!wf || !Array.isArray(wf)) return false;
        return wf.find(wf => wf?.fields);
    }

    const onExecuteWorkflowClick = (e) => {
        e.preventDefault();
        if(!workflowHasFields(activeWf?.wf)){
            const autoRunComplete = (result, error) => {
                if(hasUIReloadData(activeWf?.wf)) reloadValue();
                setLoading(false);
                setAutorunWf(null);
                _setError(error);
            };
            setAutorunWf({ wf: JSON.parse(JSON.stringify(activeWf?.wf)), onComplete: autoRunComplete, autoExecute: true, formData : formData});
            setLoading(true);
        }else{
            const handleComplete = (result, error) => {
                if(hasUIReloadData(activeWf?.wf)) reloadValue();
                setWindowWf(null);
                _setError(error);
            };
            setWindowWf({ wf:  JSON.parse(JSON.stringify(activeWf?.wf)), onComplete: handleComplete, autoExecute: false, formData : formData});
        }
    }

    const reloadValue = () => {console.log("triggered");
        if(reloadDataForce) reloadDataForce();
    };

    const hasUIReloadData = (array) => {
        if(!array || !Array.isArray(array)) return false;
        return array.some(item => item.type === "ui" && item.action === "reloadData");
    }

    const _setError = (error) => {
        if(!error) return;
        setError(error?.message || error?.Reason || t("Unknown error occured"));
        setTimeout(() => {
            setError(null);
        }, 8000);
    }

    useImperativeHandle(ref, () => ({
        onBeforeSave,
        onAfterSave
    }), [value, error, deviceData, orgData, stepData, instructions, formData,activeWf,autorunWf,windowWf,wfref,secondary]);

    return (
        <div className={`${classes["dropdown-container"]}`}>
            <div className={classes.Fcontainer}>
                <fieldset key={fieldName} className={classes["input-container"]}>
                    <label htmlFor={fieldName}>
                        {instructions?.label || fieldName}
                        {instructions?.instructionsText && <GenericTooltip tooltip={instructions?.instructionsText} fieldName={fieldName} placement="left"/>}
                        {/* {instructions?.instructions && <OverlayTrigger overlay={<Tooltip>{instructions?.instructions}</Tooltip>}>
                            <OpenInNewIcon className={`ms-1 ${classes["hyperlink-icon"]}`} style={{height:"0.9rem", width:"0.9rem"}}/>
                        </OverlayTrigger>} */}
                        {instructions?.instructions && (() => {
                            const isUrl = /^https?:\/\//i.test(instructions?.instructions); // simple URL check
                            return (
                                <OverlayTrigger overlay={<Tooltip>{instructions?.instructions}</Tooltip>}>
                                <OpenInNewIcon
                                    className={`ms-1 ${classes["hyperlink-icon"]}`}
                                    style={{ height: "0.9rem", width: "0.9rem", cursor: isUrl ? "pointer" : "default" }}
                                    onClick={isUrl ? () => window.open(instructions?.instructions, "_blank") : undefined}
                                />
                                </OverlayTrigger>
                            );
                        })()}
                    </label>
                    <input
                        type={instructions?.type || "text"}
                        value={value}
                        disabled={instructions?.editable===false || loading}
                        onChange={(e) => onInputChange(e.target.value)}
                        placeholder={instructions?.placeholder}
                        className={`${classes["dropdown-text-field"]}`}
                        style={{borderRadius: "8px"}}
                    />
                </fieldset>            
                {activeWf && <>
                    {isButtonWf(activeWf?.wf) ? 
                        <><Button disabled={loading} className="ms-2 ps-2 pe-2 pt-1 pb-1 h-auto align-self-end" onClick={onExecuteWorkflowClick}>{isButtonWf(activeWf?.wf)?.execute?.button}</Button></>
                        :
                        <><Workflow ref={wfref} orgData={orgData} deviceData={deviceData} formData={activeWf.formData} stepData={stepData} workflow={activeWf?.wf} onComplete={activeWf?.onComplete} value={value} autoExecute={activeWf?.autoExecute}/></>}
                </>}
                {autorunWf && <><Workflow ref={wfref} orgData={orgData} deviceData={deviceData} formData={autorunWf?.formData} stepData={stepData} workflow={autorunWf?.wf} onComplete={autorunWf?.onComplete} value={value} autoExecute={autorunWf?.autoExecute}/></>}
                {secondary && <><Workflow ref={wfref} orgData={orgData} deviceData={deviceData} formData={secondary?.formData} stepData={stepData} workflow={secondary?.wf} onComplete={secondary?.onComplete} value={value} autoExecute={secondary?.autoExecute}/></>}
                <GenericModal show={!!windowWf} onHide={() => setWindowWf(null)} title={t("Enter data")} size="md">
                    {windowWf && <Workflow ref={wfref} orgData={orgData} deviceData={deviceData} formData={windowWf.formData} stepData={stepData} workflow={windowWf?.wf} onComplete={windowWf?.onComplete} value={value} autoExecute={windowWf?.autoExecute}/>}
                </GenericModal>
                {error && <div className="alert alert-danger mt-2 w-100">{error}</div>}
            </div>
        </div>
  );
});

export default WorkflowTextInput;


const aa = {
    "FiscUnitRegCodeDef": {
        "type" : "text",
        "label" : "Unit registration code",
        "required": false,
        "editable": true,   //če je tole false, potem imajo samo select opcijo, če je vpisan OrgUnitId
        "instructions": "https://miniblagajna.fu.gov.si",
        "instructionsText": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju in je bila predhodno registrirana na davčnem portalu za potrebe fiskalizacije. Več na https://www.fu.gov.si/fileadmin/Internet/Nadzor/Podrocja/Davcne_blagajne_in_VKR/Opis/Davcne_blagajne_in_davcno_potrjevanje_racunov.docx",
        "OrgUnitId" : {//specifike connectiona. Če ni možen connection, ga ni noter
            "workflow" : [  //workflow lahko zahteva manual executeion ali ne. Če daš "button" param noter, potem 
            {
                "name" : "unique-name",
                "type" : "table",
                "table" : "EU_Units",
                "fields" : {
                    "FiscUnitRegCode": {
                        "required": true,
                        "editable": true,
                        "Title": "Oznaka poslovnega prostora",
                        "Tooltip": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju.Oznaka je lahko sestavljena iz številk in črk 0-9, a-z, A-Z.Oznaka mora biti enaka kot tista, ki je navedena na računih. Oznaka je enkratna na nivoju zavezanca.",
                        "minlength": 1,
                        "maxlength": 20,
                        "example": "LK1",
                        "default" : "<!--aorg.Id-->",
                        "init": null
                    }
                }, //list of fields displayed
                "execute" : {"method" : "Data.Create", "params" : {"values" : {}}} //vsa field polja bodo avtomatsko dodana v values tudi
            },
            {
                "type" : "extension",
                "fields" : null,
                "execute" : {"method" : "EUeInvoices.RegisterBusinessPremise", "button" : "Register", "params" : {"Mode": "PROD", "UnitId" : "<!--workflow.unique-name.response.values.0.id-->", "UnitRegCode" : "<!--workflow.unique-name.fields.FiscUnitRegCode.value-->"}}
            },
            {
                "type" : "ui",
                "action" : "reloadData"     //refreshes the device data on display, in case anything is changed by extensions for example
            },
            {
                "name" : "unique-name",
                "type" : "table",
                "table" : "EU_Units",
                "fields" : {
                    "FiscUnitRegCode": {
                        "required": true,
                        "editable": true,
                        "Title": "yolo",
                        "Tooltip": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju.Oznaka je lahko sestavljena iz številk in črk 0-9, a-z, A-Z.Oznaka mora biti enaka kot tista, ki je navedena na računih. Oznaka je enkratna na nivoju zavezanca.",
                        "minlength": 1,
                        "maxlength": 20,
                        "example": "LK1",
                        "default" : "<!--aorg.Id-->",
                        "init": null
                    }
                }, //list of fields displayed
                "execute" : {"method" : "Data.Create", "params" : {"values" : {}}} //vsa field polja bodo avtomatsko dodana v values tudi
            },
            {
                "type" : "extension",
                "fields" : null,
                "execute" : {"method" : "EUeInvoices.RegisterBusinessPremise", "button" : "Finish", "params" : {"Mode": "PROD", "UnitId" : "<!--workflow.unique-name.response.values.0.id-->", "UnitRegCode" : "<!--workflow.unique-name.fields.FiscUnitRegCode.value-->"}}
            },
            {
                "type" : "ui",
                "action" : "setvalue",
                "value" : "<!--workflow.unique-name.response.values.0.id-->"
            }]
        }
    }
}